import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { MyTrans } from '@halo/ui-react';
import { useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupUpdateContentProps {
  message: Msg;
}

export const MsgGroupUpdateContent = memo(function MsgGroupUpdateContent({
  message,
}: MsgGroupUpdateContentProps) {
  const { new_name, operator_user_id } = message.payload;

  const { user: operatorUser } = useUserInfo(operator_user_id);

  return (
    <MyTrans
      i18nKey="chat.groupMessageUpdateText"
      components={{
        actionUser: <MsgUserText userName={operatorUser?.name || ''} userId={operator_user_id} />,
        action: <Text as="span" color="fg.muted" />,
        name: <Text as="span" color="fg.muted" />,
      }}
      values={{
        value: `'${new_name}'`,
      }}
    ></MyTrans>
  );
});
